import {
  PN_TEMPLATE_SUCCESS,
  PN_TEMPLATE_FAIL,
  CREATE_PN_TEMPLATE_SUCCESS,
  CREATE_PN_TEMPLATE_FAIL,
  UPDATE_PN_TEMPLATE_SUCCESS,
  UPDATE_PN_TEMPLATE_FAIL,
  REMOVE_PN_TEMPLATE_SUCCESS,
  REMOVE_PN_TEMPLATE_FAIL,
} from "./actionTypes";

const initialState = {
  error: [],
  res: [],
  list: [],
};

const ProgressNote = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_PN_TEMPLATE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case REMOVE_PN_TEMPLATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_PN_TEMPLATE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_PN_TEMPLATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case CREATE_PN_TEMPLATE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case CREATE_PN_TEMPLATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case PN_TEMPLATE_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case PN_TEMPLATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default ProgressNote;
